import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import { appConstant, apiUrl } from '@constants';

export function* loginWorker(action) {
	try {
		const uri = `${appConstant.domain + apiUrl.HEALTH}`;
		yield call(Axios.get, uri);
		const loginURI = `${appConstant.domain + apiUrl.LOGIN}`;
		const res = yield call(Axios.post, loginURI, action.request);

		yield localStorage.setItem('authKey', JSON.stringify(btoa(res.data.messages.authKey)));
		yield localStorage.setItem('authToken', JSON.stringify(btoa(res.data.messages.authToken)));
		yield localStorage.setItem('userName', JSON.stringify(btoa(action.request.userName)));
		yield localStorage.setItem('password', JSON.stringify(btoa(action.request.password)));
		yield localStorage.setItem('ipAddress', JSON.stringify(btoa(action.request.ipAddress)));
		const uriProfile = `${appConstant.domain}${apiUrl.GET_USER}${res.data.messages.authKey}`;
		const resProfile = yield call(Axios.get, uriProfile);
		if (resProfile.data.success) {
			yield put(
				ActionsApp.creators.setUser({
					...resProfile.data.messages,
					profileImage:
						(resProfile.data.messages && resProfile.data.messages.profileImage) ||
						'https://vanderhydelawsuitattorney.com/images/avatar.png',
				})
			);
		}
		yield put(Actions.creators.loginSuccess({ ...res.data.messages }));
		if (!action.fromApp) {
			yield action.history.push('/dashboard');
		}
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.loginCompleted());
	}
}

export default function* loginWatcher() {
	yield takeEvery(Actions.types.LOGIN_STARTED, loginWorker);
}
